// Pulls a human-readable message out of a graphql-request ClientError (our
// resolvers raise GraphQL::ExecutionError with a user-facing message), falling
// back to a generic string.
import { i18n } from "../../i18n";

export function genericErrorMessage(): string {
  return i18n.global.t("purchases.error_message.something_went_wrong");
}

export function errorMessage(error: unknown): string {
  const anyErr = error as { response?: { errors?: Array<{ message?: string }> }; message?: string };
  const graphqlMessage = anyErr?.response?.errors?.[0]?.message;
  if (graphqlMessage) return graphqlMessage;
  if (anyErr?.message) return anyErr.message;
  return genericErrorMessage();
}
